import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipPeople, TPostClipPeople } from '../types';

export async function postClipPeople(body: TPostClipPeople): Promise<TClipPeople> {
  return mediaManagerClient.post('/api/v1/clip_people', emptyStringValues(body));
}

type MutationFn = typeof postClipPeople;

type TUsePostFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

type TPostClipPeopleSilently = TPostClipPeople & { silently?: boolean };

export function usePostClipPeople({
  config = {},
  invalidateClipQueries = false,
}: TUsePostFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPostClipPeopleSilently) =>
      postClipPeople({ ...(body as TPostClipPeople), silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido crear la persona de inteŕes del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TPostClipPeopleSilently) {
      if (!variables.silently) {
        addSuccessNotification(t('La persona de interés del corte se ha creado correctamente'));
      }
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
